import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.aiReaction.curious',
    subtitle: 'pages.onboarding.aiReaction.curiousSub',
    value: 'curious',
  },
  {
    title: 'pages.onboarding.aiReaction.nervous',
    subtitle: 'pages.onboarding.aiReaction.nervousSub',
    value: 'nervous',
  },
  {
    title: 'pages.onboarding.aiReaction.ignore',
    subtitle: 'pages.onboarding.aiReaction.ignoreSub',
    value: 'ignore',
  },
  {
    title: 'pages.onboarding.aiReaction.confident',
    subtitle: 'pages.onboarding.aiReaction.confidentSub',
    value: 'confident',
  },
  {
    title: 'pages.onboarding.aiReaction.adapting',
    subtitle: 'pages.onboarding.aiReaction.adaptingSub',
    value: 'adapting',
  },
]

export default function AiReactionPage() {
  return (
    <OnboardingQuestionPage
      eyebrow="pages.onboarding.aiReaction.eyebrow"
      answers={answers}
      title="pages.onboarding.aiReaction.title"
      subtitle="pages.onboarding.aiReaction.subtitle"
    />
  )
}
